// extracted by mini-css-extract-plugin
module.exports =  {"link":"_32bbee5fda--link--wcE0Q","title":"_32bbee5fda--title--tlXoI","image":"_32bbee5fda--image--PwvlP","label":"_32bbee5fda--label--Abngi"};